<template>
    <div class="flex mt-4 flex-wrap md:flex-nowrap pb-10 md:pb-0">
        <form-values
            class="relative xl:mr-8 lg:w-2/5 md:w-2/5 w-full"
            form-height="calc(100vh - 320px)"
            wrapper-max-height="546px"
            form-pb-bottom="pb-0"
            :form="form"
            :paddind-top-inputs="'mt-6'"
            :title="'Adicionar envio'"
            :errors="errors"
            @input="form[$event.type] = $event.value"
            @go-back="goBack"
            @submit.native.prevent="addPayment"
        >
            <template slot="favored">
                <div class="relative">
                    <jet-label class="text-gray-800" for="goal" value="Favorecido"/>
                    <jet-input
                        class="mt-1 block w-full "
                        v-model.trim="form.contact"
                        placeholder="Nome ou CPF/CNPJ"
                    />
                    <jet-input-error :message="form.error('contact') || errors.contact" class="absolute -bottom-5"/>
                </div>
            </template>

            <template slot="account">
                <div class="relative">
                    <jet-label class="text-gray-800" for="goal" value="Conta destino"/>
                    <jet-auto-complete
                        v-model="form.account"
                        class="mt-1 block w-full "
                        :options-list="[]"
                    />
                    <jet-input-error :message="form.error('account') || errors.account" class="absolute -bottom-5"/>
                </div>
            </template>

            <template slot="schedule">
                <div class="relative">
                    <jet-label class="text-gray-800" for="goal" value="Agendar pagamento para"/>
                    <jet-date-picker
                        class="mb-0 relative"
                        v-model="form.scheduled"
                        :is-clear-button="false"
                        :is-calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :disabled-dates="disableDates"
                    >
                    <slot slot="description">
                        <span class="absolute capitalize top-2 left-24 ml-2 pointer-events-none">{{ dayDescription }}</span>
                    </slot>
                    </jet-date-picker>
                    <jet-input-error :message="form.error('scheduled') || errors.scheduled" class="absolute -bottom-5"/>
                </div>
            </template>

            <template slot="goal">
                <div class="relative goal">
                    <jet-label class="text-gray-800" for="goal" value="Finalidade"/>
                    <jet-auto-complete
                        v-model="form.goal"
                        class="mt-1 block w-full "
                        :options-list="$page.props.goal_list"
                    />
                    <jet-input-error :message="form.error('goal') || errors.goal" class="absolute -bottom-5"/>
                </div>
            </template>

            <template slot="actions">
                <div class="bg-white flex justify-between sticky bottom-0 w-full left-0 py-3 z-10">
                    <jet-secondary-button
                        class="sm:border-2 sm:border-black capitalize sm:tracking-normal px-7 py-2 sm:rounded"
                        @click.native="resetForm"
                    >
                        Limpar
                    </jet-secondary-button>
                    <jet-button class="sm:tracking-normal capitalize px-5 py-2 sm:rounded">
                        {{ isEdit ? 'Editar' : 'Adicionar' }}
                    </jet-button>
                </div>
            </template>
        </form-values>

        <div class="rounded flex-1 pt-4 relative flex flex-col justify-between">
            <div>
                <h4 class="font-medium ml-8 mb-3">Lista de envios</h4>
                <div
                    ref="listPayments"
                    class="md:overflow-y-auto md:pr-3 w-full md:w-auto table md:block"
                    style="height: calc(100vh - 372px); max-height: 494px;"
                >
                    <lot-item
                        v-for="payment in payments"
                        class="mb-4 last:mb-0"
                        :key="payment.id + Math.random()"
                        :lot="payment"
                        @remove="removePayment"
                        @edit="editPayment"
                    />
                    <p v-show="!payments.length" class="text-center font-semibold mt-28">A lista de envios está vazia. Adicione ao lado.</p>
                </div>
            </div>
            <div class="sticky bottom-4 md:bottom-0 flex justify-between items-center bg-white shadow-card px-5 py-2 md:mr-3">
                <div class="flex">
                    <div class="mr-8">
                        <span class="block text-xs text-gray-500 opacity-90">Total a ser enviado</span>
                        <span class="block text-xs font-bold leading-none">R$ <span class="text-base">{{ total }}</span></span>
                    </div>
                    <div>
                        <span class="block text-xs text-gray-500 opacity-90">Quantidade de pagamentos</span>
                        <span class="block text-sm font-bold leading-6">{{ payments.length }}</span>
                    </div>
                </div>
                <div>
                    <button
                        class="bg-green-500 hover:bg-green-600 text-white text-xs leading-none px-6 py-3 rounded font-medium"
                        :class="!payments.length ? 'cursor-not-allowed': ''"
                        :disabled="!payments.length"
                        @click="$emit('next', { payments, total})"
                    >
                            Finalizar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import FormValues from '../../components/FormValues.vue';
import JetInput from "../../../../Jetstream/Input.vue";
import JetInputError from "../../../../Jetstream/InputError.vue";
import JetAutoComplete from "../../../../Jetstream/AutoComplete.vue";
import JetLabel from "../../../../Jetstream/Label.vue";
import JetDatePicker from "../../../../Jetstream/DatePicker.vue";
import JetSecondaryButton from '../../../../Jetstream/SecondaryButton.vue';
import JetButton from '../../../../Jetstream/Button.vue';
import LotItem from '../../components/LotItem.vue';
moment.locale('pt-br')

const paymentFake = () =>  ({
    id: Math.floor(Math.random() * 360),
    favored: {
        document: 'CPF: 423.546.458-45',
        name: 'josimar rocha',
        initialsName: 'JR',
        bgItemList: `hsl(${Math.floor(Math.random() * 360)}, 75%, 56%)`
    },
    scheduled: {
        date: new Date().toISOString(),
        description: '(Hoje)'
    },
    amount: '1.500,00',
    description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit',
    receiveCode: '2GO Bank',
    goal: { name: 'Cartão de crédito'},
    bank: {
        agency: '12344',
        id: null,
        name: 'BMP Plus',
        number: '274',
        account: {
            number: '15456',
            digit: '4'
        }
    },
})
const errorsInitial = {
    contact: null,
    amount: null,
    scheduled: null,
    account: null,
    goal: null
}
export default {
    name: "PaymentsTed",
    data(){
        return {
            selectPayment: {},
            isEdit: false,
            errors: { ...errorsInitial, },
            form: this.$inertia.form({
                amount: 0,
                goal: {},
                account: {},
                description: '',
                receiver_code: '',
                contact: '',
                scheduled: new Date().toISOString()
            }),
            payments: [paymentFake(), paymentFake(), paymentFake(), paymentFake()]
        }
    },
    computed: {
        disableDates(){
            return { to: moment().subtract(1, 'day').toDate() || null }
        },
        dayDescription(){
            const dayDescription = moment(this.form.scheduled).calendar().split(' ')
            return dayDescription.length > 1 ? `(${dayDescription[0]})` : ''
        },
        total(){
            const totalNumber = this.payments.reduce((acc, actual) => {
                const numberFormatted = actual.amount.replace('.', '').replace(',', '.')
                return parseFloat(numberFormatted) + acc
            }, 0)
            return new Intl.NumberFormat('pt-br', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(totalNumber)
        }
    },
    methods: {
        resetForm(){
            this.form.reset()
            this.errors = { ...errorsInitial }
        },
        goBack(){
            window.history.back()
        },
        removePayment(payment){
            this.payments = this.payments.filter((lot) => lot.id !== payment.id)
        },
        editPayment(payment){
            this.isEdit = true
            this.selectPayment = payment
            this.form.amount = payment.amount
            this.form.contact = payment.favored.key.split(':')[1].trim()
            this.form.scheduled = payment.scheduled.date
            this.form.receiver_code = payment.receiveCode
            this.form.description = payment.description
            this.form.goal = payment.goal
            this.form.account = payment.account
        },
        async addPayment(){
            this.errors = { ...errorsInitial }
            if(!this.validateForm()) return

            const newPayment = {
                ...paymentFake(),
                id: Math.floor(Math.random() * 360),
                favored: {
                    key: `CPF: ${this.form.contact}`,
                    customer: 'Jão',
                    initialsName: 'JA',
                    bgItemList: `hsl(${Math.floor(Math.random() * 360)}, 75%, 56%)`
                },
                amount: this.form.amount,
                description: this.form.description,
                receiveCode: this.form.receiver_code,
                goal: this.form.goal,
                scheduled: {
                    date: this.form.scheduled,
                    description: this.dayDescription
                },
            }
            if (this.isEdit){
                this.payments = this.payments.map((payment) => payment.id === this.selectPayment.id ? newPayment : payment )
                this.isEdit = false
            } else {
                this.payments.push(newPayment)
            }
            this.resetForm()
            this.$nextTick(() => this.$refs.listPayments.scrollBy({ top: 999999, behavior: 'smooth' }))
        },
        validateForm(){
            const amount = this.form.amount.replace(',', '.')
            if (parseFloat(amount) === 0) {
                this.errors.amount = 'Informe o valor da operação'
            }
            if (!this.form.goal.id) {
                this.errors.goal = 'Selecione uma finalidade'
            }

            const isName = this.form.contact.replace(/[0-9\.-]+/ig, '')
            if(!this.form.contact) {
                this.errors.contact = 'Nome ou CPF/CNPJ inválido'
            } else if(!isName) {
                const documentReplaced = this.form.contact.replace(/[-\./\s]+/gi, '')
                if(documentReplaced.length !== 11 && documentReplaced.length !== 14){
                    this.errors.contact = 'CPF/CNPJ inválido'
                }
            } else if(/[a-z]+/gi.test(this.form.contact) && /[0-9]+/gi.test(this.form.contact)) {
                this.errors.contact = 'Nome ou CPF/CNPJ inválido'
            }
            return !Object.keys(this.errors).some((errorName) => !!this.errors[errorName])
        },
        scrollBottom(){
            const form = document.getElementById('form-values')
            setTimeout(() => form.scrollBy({ top: form.scrollHeight, behavior: 'smooth' }), 200)
        },
        handleScroll(removeOrAddEvent){
            const inputDate = this.getEl('[name="operation_date"]')
            const iconeInputDate = this.getEl('.vdp-datepicker__calendar-button')
            const inputGoal = this.getEl('.goal .vs__search')
            inputGoal && inputGoal[removeOrAddEvent]('focus', this.scrollBottom)
            inputDate && inputDate[removeOrAddEvent]('click', this.scrollBottom)
            iconeInputDate && iconeInputDate[removeOrAddEvent]('click', this.scrollBottom)
        },
        getEl(element){
            return document.querySelector(element)
        }
    },
    mounted(){
        this.handleScroll('addEventListener')
    },
    beforeDestroy(){
        this.handleScroll('removeEventListener')
    },
    components: {
        FormValues,
        JetInput,
        JetInputError,
        JetLabel,
        JetDatePicker,
        JetSecondaryButton,
        JetButton,
        LotItem,
        JetAutoComplete
    }
}
</script>
